import { Check, X } from 'lucide-react';

import { cn } from '@/shared/utils/utils';

import type { RoiVerdict } from '../types/roi';

interface RoiVerdictChipProps {
  verdict: RoiVerdict;
  className?: string;
}

export function RoiVerdictChip({ verdict, className }: RoiVerdictChipProps) {
  const isCaught = verdict === 'caught';
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide',
        isCaught
          ? 'border-green-200 bg-green-50 text-green-700'
          : 'border-rose-200 bg-rose-50 text-rose-700',
        className
      )}
    >
      {isCaught ? (
        <Check className="h-3.5 w-3.5" />
      ) : (
        <X className="h-3.5 w-3.5" />
      )}
      {isCaught ? 'Caught' : 'Not caught'}
    </span>
  );
}
